// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"bookmark-checked"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M11 4H5V21L12 16L19 21V11","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M21.1823 2.93945L16.9397 7.18209L14.8184 5.06077","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const BookmarkCheckedIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'bookmark-checked',
    ref,
    icon: element,
  },
));

BookmarkCheckedIcon.displayName = 'BookmarkCheckedIcon';

export default BookmarkCheckedIcon;
